"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useDonationPopupData;
const react_1 = __importDefault(require("react"));
const page_data_utils_1 = require("~/helpers/page-data-utils");
function useDonationPopupData() {
    // When useDataFromSlug moves to TS, we can make it type-generic
    const data1 = (0, page_data_utils_1.useDataFromSlug)('donations/donation-popup');
    const data = react_1.default.useMemo(() => ((data1 === null || data1 === void 0 ? void 0 : data1.length) > 0 ? data1[0] : {}), [data1]);
    return data;
}
